import { ToolBase, ToolPointer } from './tool';
import { pickAt } from './picking';
import { eraseEdges } from '../core/ops';

/** Radiergummi (E): Klicken/Ziehen löscht Kanten (Flächen kaskadieren) und Flächen. */
export class EraserTool extends ToolBase {
  readonly id = 'eraser';
  readonly label = 'Radiergummi';
  readonly shortcut = 'E';
  readonly cursor = 'crosshair';
  readonly hint = 'Über Kanten/Flächen ziehen zum Löschen · Umschalt hält sich an Kanten';

  private isErasing = false;
  private erasedInStroke = false;

  enter(): void {
    this.isErasing = false;
    this.erasedInStroke = false;
  }

  exit(): void {
    this.ctx.renderer.hoverFaceId = null;
    this.ctx.requestUpdate();
  }

  pointerDown(e: ToolPointer): void {
    if (e.button !== 0) return;
    this.isErasing = true;
    this.erasedInStroke = false;
    this.eraseAt(e);
  }

  pointerMove(e: ToolPointer): void {
    if (!this.isErasing) {
      // Hover-Hervorhebung
      const { faceId } = pickAt(this.ctx, e);
      this.ctx.renderer.hoverFaceId = faceId;
      this.ctx.requestUpdate();
      return;
    }
    this.eraseAt(e);
  }

  private eraseAt(e: ToolPointer): void {
    const { edgeId, faceId } = pickAt(this.ctx, e);
    if (edgeId === null && faceId === null) return;
    const model = this.ctx.model;
    const entity = edgeId !== null ? model.edges.get(edgeId) : model.faces.get(faceId!);
    // Geschlossene Gruppe → als Ganzes löschen; Geometrie außerhalb der offenen Gruppe bleibt
    const whole = entity && !model.isEditable(entity) ? model.expandToGroups(edgeId !== null ? [edgeId] : [], faceId !== null ? [faceId] : []) : null;
    if (whole && whole.edges.size + whole.faces.size === 0) return;
    if (!this.erasedInStroke) {
      this.ctx.beginEdit();
      this.erasedInStroke = true;
    }
    if (whole) {
      for (const id of whole.faces) model.deleteFace(id);
      eraseEdges(model, whole.edges);
    } else if (edgeId !== null) {
      eraseEdges(this.ctx.model, [edgeId]);
    } else if (faceId !== null) {
      this.ctx.model.deleteFace(faceId);
    }
    this.ctx.requestUpdate();
  }

  pointerUp(_e: ToolPointer): void {
    this.isErasing = false;
    this.erasedInStroke = false;
    this.ctx.renderer.hoverFaceId = null;
    this.ctx.requestUpdate();
  }

  cancel(): void {
    this.isErasing = false;
    this.ctx.renderer.hoverFaceId = null;
    this.ctx.requestUpdate();
  }
}
